import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, NavigationEnd, Event } from '@angular/router';
import { IBreadCrumb } from './breadcrumb.interface';
import { filter, distinctUntilChanged } from 'rxjs/operators';

@Component({
  selector: 'app-breadcrumbs',
  templateUrl: './breadcrumbs.component.html',
  styleUrls: ['./breadcrumbs.component.css']
})
export class BreadcrumbsComponent implements OnInit {
  public breadcrumbs: IBreadCrumb[]

  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
  ) {
    this.breadcrumbs = this.buildBreadCrumb(this.activatedRoute.root, '');
  }

  currentUrl: string;

  ngOnInit() {
    this.router.events.pipe(
      filter((event: Event) => event instanceof NavigationEnd),
      distinctUntilChanged(),
    ).subscribe((event: NavigationEnd) => {
      this.breadcrumbs = this.buildBreadCrumb(this.activatedRoute.root, event.url);

      this.currentUrl = event.url;

      // Gets the index of the url we are currently on
      const existingIndex = this.breadcrumbs.findIndex(e => `/${e.url}` == event.url);

      // Gets the visited URLs (handles if the users goes back)
      const visitedUrls = this.breadcrumbs.slice(0, existingIndex + 1);

      // Checks the breadcrumbs against the visisted URLS and sets breadcrumb to visited
      this.breadcrumbs.forEach(element => {
        visitedUrls.forEach(visitedElement => {
          if (element.url == visitedElement.url) {
            element.visited = true;
          }
        });
      });
    })
  }

  // Builds the array of breadcrumbs using the router
  buildBreadCrumb(activatedRoute: ActivatedRoute, url: string, breadcrumbs: IBreadCrumb[] = []): IBreadCrumb[] {
    let newBreadcrumbs = [];
    for (let index = 0; index < this.router.config.length; index++) {
      const route = this.router.config[index];

      const breadcrumb: IBreadCrumb = {
        label: route.data ? route.data.breadcrumb : null,
        url: route.path,
        visited: false
      };

      // Set location always visited
      if (breadcrumb.url == 'location') {
        breadcrumb.visited = true;
      }

      let responseCode;
      activatedRoute.queryParams.subscribe(params => {
        responseCode = params['responseCode'];
      });

      // Set all breadcrumbs to visited
      if (url && url.includes('confirmation') && responseCode && responseCode == '00') {
        breadcrumb.visited = true;
      }

      // Set all breadcrumbs before confirmation to visited
      if (url && url.includes('confirmation') && responseCode && responseCode !== '00' && breadcrumb.url != 'confirmation') {
        breadcrumb.visited = true;
      }

      breadcrumb.label ? newBreadcrumbs.push(breadcrumb) : {};
    }

    return newBreadcrumbs;
  }
}
